const domain = 'https://admin.zhihuiyanglao.com.cn/api';
//   const domain = 'http://localhost:8080/api';
  // const domain ="http://bhang.qiangdaoapp.com/api";
export default {
  api: domain,
}



// WEBPACK FOOTER //
// ./src/js/domain.js